import React from "react";

const About = () => {
  return (
    <section id="about">
      <div className="container" style={{ paddingBottom: "78px" }}>
        <div className="card">
          <div className="card-body">
            <div className="row gx-md-8 gx-xl-10 gy-8">
              <div className="col-lg-5">
                <figure className="rounded">
                  <img
                    src="https://main.mobile.doss.co.id/storage/uploads/2022/08/paper-shoot-jadeite-cabbage-digital-camera-set2.webp"
                    alt="photoshoot"
                  />
                </figure>
              </div>
              <div className="col-lg-7">
                <h2 className="mb-3">Cara yang lebih ramah untuk berkreasi.</h2>
                <p className="lead mb-4">
                  Papershoot adalah kamera digital 16MP yang terbuat dari bahan
                  ramah lingkungan dengan <i>casing</i> yang dapat diganti-ganti
                </p>
                <div className="row">
                  <div className="col-lg-6">
                    <h3 className="mb-3">Cerita Kami</h3>
                    <p>
                      {/* <span className="dropcap">N</span> */}
                      George Lin, Pendiri Paper Shoot Camera telah mengemban
                      misinya untuk membuat kamera sederhana namun estetis yang
                      dengan mudah dapat digunakan siapa saja - baik pemula,
                      seniman, disainer atau siapapun Anda.
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <h3 className="mb-3">Spesifikasi</h3>
                    <ul className="unordered-list">
                      <li>16MP CMOS Image Resolution</li>
                      <li>Auto Exposure Compensation & WB</li>
                      <li>Support SD Memory Cards Up to 128GB</li>
                      <li>Micro USB Jack</li>
                      <li>Four Color Effects</li>
                      <li>Normal / Black & White / Sepia / Blue</li>
                      <li>Add Time-lapse, 1080p, 10sec Video</li>
                      <li>DIY Assembly</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
